import { render, staticRenderFns } from "./EditRepository.vue?vue&type=template&id=6cab83d2&"
import script from "./EditRepository.vue?vue&type=script&lang=js&"
export * from "./EditRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cab83d2')) {
      api.createRecord('6cab83d2', component.options)
    } else {
      api.reload('6cab83d2', component.options)
    }
    module.hot.accept("./EditRepository.vue?vue&type=template&id=6cab83d2&", function () {
      api.rerender('6cab83d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/EditRepository.vue"
export default component.exports